<template>
  <div class="wrap">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="header-individual short" :class="header_notification ? 'header-notification-space' : ''">
      <router-link to="/report">
        <div class="pointer" style="font-size: 11px; color: #666"><font-awesome-icon :icon="['fas', 'arrow-left']" style="margin-right: 5px" />レポート一覧に戻る</div>
      </router-link>
    </div>

    <!-- ユーザーページ -->
    <div class="list-detail-page-wrap">
      <div v-if="report_id == 'demo' && demo_notification" class="demo-report-wrap">
        <div class="demo-report-notification">
          この画面では架空のデモレポートを表示しています。デモレポートは内容の変更は行えません。
          <div class="flex-space"></div>
          <font-awesome-icon :icon="['fal', 'times']" style="cursor: pointer; padding: 5px 10px" @click="demo_notification = false" />
        </div>
      </div>
      <div class="list-breadcrumb-wrap report">
        <div class="list-summary max-width" :class="loading ? 'transparent' : ''">
          <div class="list-breadcrumb-image" @click="img_change = true">
            <div class="i-detail-header-sns-type instagram">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </div>
            <div class="list-breadcrumb-icon">
              <font-awesome-icon :icon="['fas', 'camera-alt']" />
            </div>
            <el-image :src="report.summary.img_url" class="data-table-profile list_img" fit="cover">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['far', 'chart-bar']" />
              </div>
            </el-image>
          </div>
          <div class="list-breacrumb-namearea" v-if="!loading">
            <div class="list-breadcrumb-name">
              <div>{{ loading ? "" : report.summary.report_name }}</div>
              <el-tooltip>
                <div slot="content">レポート名を変更</div>
                <i class="el-icon-edit pointer" style="color: #aaa; font-size: 14px; margin-left: 10px" @click="report_id == 'demo' ? '' : openChangeReport()"></i>
              </el-tooltip>
            </div>
            <div class="list-breadcrumb-description flex-wrap">
              <span v-if="report.summary.report_type == 'manual'" style="color: #666; margin-right: 5px"
                ><font-awesome-icon :icon="['fal', 'file-csv']" style="margin-right: 3px;" /> Excelよりインポート&nbsp;・</span
              >
              <span v-if="report.summary.report_type != 'manual'" style="color: #666; margin-right: 5px">トラッキングタグ:</span>
              <span v-if="report.summary.trackingtag == 'off'" style="margin-right:10px;">設定しない&nbsp;</span>
              <span v-else-if="report.summary.mentiontag">
                <span v-for="mentiontag in report.summary.mentiontag" :key="mentiontag.id">{{ mentiontag }}&nbsp;</span>・
              </span>
              <span v-if="report.summary.hashtag">
                <span v-for="hashtag in report.summary.hashtag" :key="hashtag.id">{{ hashtag }}&nbsp;</span>・
              </span>
              <span v-if="report.summary.keyword && report.summary.keyword != null">
                <span>{{ report.summary.keyword.join(', ') }}&nbsp;</span>
              </span>
              <span v-if="report.summary.report_type != 'manual'" style="color: #666; margin-right: 5px">トラッキング期間:</span>
              <span v-else style="color: #666; margin-right: 5px">データ集計期間:</span>
              <span>
                {{ report.summary.start_at | date }}~
                <span v-if="report.summary.end_at">{{ report.summary.end_at | date }}</span>
                <span v-else></span>
                ・</span
              >
              &nbsp;{{ report.summary.created_at | lastUpadate }}に作成
            </div>
          </div>
        </div>
        <div class="list-detail-menu-wrap right-auto">
          <div class="list-detail-menu">
            <el-button :disabled="loading" type="info" @click="settingOpen()" v-if="report.summary.report_type != 'manual'">
              <font-awesome-icon :icon="['fas', 'cog']" />
            </el-button>
            <el-tooltip placement="top" :disabled="export_report_enabled">
              <div class="activate-popover" slot="content">
                <div class="pointer" @click="toSetting">アップグレード</div>
                でご利用いただけます
              </div>
              <span style="margin-left: 10px;">
                <el-button type="info" :disabled="loading || !export_report_enabled" @click="exportReportDetail()">
                  <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right:5px" />エクスポート
                </el-button>
              </span>
            </el-tooltip>
            <el-dropdown trigger="click" placement="bottom-start" style="margin-left:10px">
              <el-button :disabled="loading" type="primary" icon="el-icon-plus" style="margin-right: 10px">追加</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="addMedia()"> <font-awesome-icon :icon="['fal', 'images']" style="margin-right: 5px" />投稿を追加 </el-dropdown-item>
                <el-dropdown-item @click.native="add_influencer_modal = true" :disabled="report.summary.report_type == 'manual'">
                  <font-awesome-icon :icon="['fal', 'user']" style="margin-right: 5px" />インフルエンサーを追加
                </el-dropdown-item>
                <el-dropdown-item @click.native="add_csv_modal = true" :disabled="report.summary.report_type != 'manual'">
                  <font-awesome-icon :icon="['fal', 'file-csv']" style="margin-right: 5px" />Excel/CSVから追加
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button @click="refreshReport(true)">
              <font-awesome-icon :icon="['far', 'sync-alt']" />
            </el-button>
          </div>
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="tabClick()" class="tab-report">
          <el-tab-pane label="サマリー" name="summary">
            <reportSummary
              :summary="report.summary"
              :loading="loading"
              :report_id="report_id"
              :done_data="done_data"
              :doughnut_data="doughnut_data"
              :graph_data="graph_data"
              :reRender="reRender"
            />
          </el-tab-pane>

          <el-tab-pane label="投稿一覧" name="media">
            <reportPostList ref="reportPostList" :report_id="report_id" v-if="activeName == 'media'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>

          <el-tab-pane label="インフルエンサー" name="influencer" class="influencer_list">
            <reportInfluencer ref="reportInfluencer" :report_id="report_id" v-if="activeName == 'influencer'" @openInfluencer="openInfluencer" @loadReportDetail="loadReportDetail" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- drawer -->
      <div :class="[influencer_drawer ? 'i-detail-modal open' : 'i-detail-modal']" style="z-index: 1005" id="i-detail-scroll">
        <router-view ref="iDetail" v-show="influencer_drawer"></router-view>
      </div>
      <div :class="[influencer_drawer ? 'overlay-b open' : 'overlay-b']" @click="closeInfluencer" style="z-index: 1004"></div>

      <!-- imgChange -->
      <el-dialog title="レポートイメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
        <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" limit="1" :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            画像をドロップ
            <em>もしくは選択してアップロードしてください</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            推奨ファイル:500kb以下のjpg/png形式
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
          <el-button :disabled="report_id == 'demo'" type="primary" @click="report_id == 'demo' ? '' : imgUpload()">変更</el-button>
        </span>
      </el-dialog>

      <!-- インフルエンサー追加 -->
      <div :class="[add_influencer_modal ? 'overlay open' : 'overlay']" @click="add_influencer_modal = false"></div>
      <div :class="[add_influencer_modal && setting_modal ? 'pr-detail-modal wide-open' : add_influencer_modal ? 'pr-detail-modal open' : 'pr-detail-modal']">
        <div class="request-pr-wrap" v-if="add_influencer_modal">
          <div class="request-pr-title" style="font-size: 16px">
            インフルエンサーの追加
          </div>
          <div class="request-pr-form">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                レポート測定したいインフルエンサーを選択してください
              </div>
              <div class="request-pr-form-parts" style="flex-flow: column" v-if="report.summary.report_type != 'manual'">
                <span>追加したインフルエンサーの投稿のうち、トラッキングタグを含む投稿を自動で取得・トラッキングします。</span>
              </div>
              <div v-if="report.summary.report_type != 'manual'" class="report-detail-subtitle">トラッキングタグ:</div>
              <div v-if="report.summary.report_type != 'manual'" class="request-pr-form-parts" style="flex-flow: column">
                <div class="report-detail-trackingtag" @click="settingOpen()" @mouseover="trackingtag_on = true" @mouseleave="trackingtag_on = false">
                  <span v-for="hashtag in report.summary.hashtag" :key="hashtag.id">{{ hashtag }},</span>
                  <span v-for="mentiontag in report.summary.mentiontag" :key="mentiontag.id">{{ mentiontag }},</span>
                  <span v-for="keyword in report.summary.keyword" :key="keyword.id">{{ keyword }}</span>
                  <span v-if="report.summary.mentiontag == '' && report.summary.hashtag == '' && report.summary.keyword == ''">
                    <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 5px" />トラッキングタグが設定されていません
                  </span>
                  <div class="flex-space"></div>
                  <transition name="fade">
                    <font-awesome-icon :icon="['far', 'chevron-right']" style="margin-right: 5px" v-show="trackingtag_on" />
                  </transition>
                </div>
              </div>
              <influencerSuggest
                :referer="'report'"
                :sns_type="'instagram'"
                :influencer_list.sync="report.influencer_list"
                :report_switch.sync="report.report_switch"
                :checkList.sync="report.checkList"
              />
            </div>
            <div class="request-pr-form-buttonarea">
              <div class="report-detail-noinfluencer">
                追加したいインフルエンサーが登録されていない場合は
                <router-link to="/request" target="_blank">
                  <span class="router-link"
                    >こちら
                    <font-awesome-icon :icon="['far', 'external-link']" style="margin-right: 3px;" />
                  </span>
                </router-link>
                からリクエストできます
              </div>
              <div class="flex-space"></div>
              <el-button @click="report_id == 'demo' ? '' : addInfluencer()" type="primary" :disabled="add_loading || report_id == 'demo'">
                <div class="flex-row">
                  インフルエンサーを追加
                  <div class="loader--mini" v-show="add_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- ハッシュタグ・メンションタグ設定 -->
      <div class="overlay" :class="[setting_modal ? 'overlay open' : 'overlay']" @click="settingClose()" style="z-index: 1002"></div>
      <div :class="[setting_modal ? 'pr-detail-modal open' : 'pr-detail-modal']" style="z-index: 1003">
        <div class="request-pr-wrap" v-if="setting_modal">
          <div class="request-pr-title" style="font-size: 16px">
            レポート設定
          </div>
          <div class="request-pr-form">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">トラッキングタグ</div>
              <div class="request-pr-form-parts" style="margin-bottom: 20px">
                <ul class="request-pr-form-description">
                  <li>設定したトラッキング期間中、レポートにアサインされたインフルエンサーの投稿のうち、指定のハッシュタグもしくはメンションタグ、キーワードを含む投稿を自動で取得します。</li>
                  <li>ハッシュタグでトラッキングする場合は、ブランド名やキャンペーン名を含むようなユニークなハッシュタグを設定してください。</li>
                  <li style="margin-bottom:0">トラッキングタグが設定されていない場合は、トラッキング期間中の全ての投稿を取得します。</li>
                </ul>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキングタグ
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input" style="margin-top:10px">
                    <el-radio v-model="report.summary.trackingtag" label="on" disabled style="margin-right: 20px;">設定する</el-radio>
                    <el-radio v-model="report.summary.trackingtag" label="off" disabled>設定しない(トラッキング期間の全投稿を取得)</el-radio>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  ハッシュタグ(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input
                      @keyup.enter.native="addHashtag()"
                      @blur="enter_on ? '' : addHashtag()"
                      v-model="edit.hashtagValue"
                      placeholder="ハッシュタグを入力(Enterで追加)"
                      :disabled="report_id == 'demo'"
                    >
                      <template slot="prepend">
                        <font-awesome-icon :icon="['fal', 'hashtag']" />
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ edit.hashtag.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="hashtag in edit.hashtag" :key="hashtag.id">
                      {{ hashtag }}
                      <div :key="hashtag" @click="deleteHashtag(hashtag)">
                        <font-awesome-icon
                          :icon="['fas', 'times']"
                          style="
                            cursor: pointer;
                            margin-left: 10px;
                            font-size: 14px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">メンションタグ</div>
                <mentiontagSuggest :create="true" :report_id="'demo'" @syncMentiontag="syncMentiontag" v-if="report.summary.mentiontag == ''" />
                <div class="request-pr-form-hashtag" v-else>
                  <el-tooltip placement="top-start">
                    <div slot="content">メンションタグは変更できません</div>
                    <div class="request-pr-form-hashtag-wrap">
                      <div class="request-pr-form-add-box mention">
                        <div>
                          <div>{{ report.summary.mentiontag[0] }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.summary.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  キーワード(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input
                      @keyup.enter.native="addKeyword()"
                      @blur="enter_on ? '' : addKeyword()"
                      v-model="edit.keywordValue"
                      placeholder="キーワードを入力(Enterで追加)"
                      :disabled="report_id == 'demo'"
                    >
                      <template slot="prepend">
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ edit.keyword.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="keyword in edit.keyword" :key="keyword.id">
                      {{ keyword }}
                      <div :key="keyword" @click="deleteKeyword(keyword)">
                        <font-awesome-icon
                          :icon="['fas', 'times']"
                          style="
                            cursor: pointer;
                            margin-left: 10px;
                            font-size: 14px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキング期間
                  <el-tooltip>
                    <div slot="content">
                      最大2ヶ月間自動でトラッキングを行います
                    </div>
                    <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px; color: #aaa" />
                  </el-tooltip>
                </div>
                <el-tooltip placement="top-start">
                  <div slot="content">トラッキング期間は変更できません</div>
                  <span>
                    <div class="report-date-row">
                      <el-date-picker
                        v-model="report.summary.start_at"
                        type="date"
                        placeholder="トラッキング開始日を選択してください"
                        format="yyyy/MM/dd"
                        value-format="yyyy-MM-dd"
                        style="width: 50%"
                        disabled
                      ></el-date-picker>
                      <div class="report-date-space">〜</div>
                      <el-date-picker v-model="end_at" disabled type="date" placeholder="自動選択されます" format="yyyy/MM/dd" value-format="yyyy/M/dd" style="width: 50%"></el-date-picker>
                    </div>
                  </span>
                </el-tooltip>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <el-button @click="changeReportSetting()" type="primary" :disabled="setting_loading || change_flag == 0 || report_id == 'demo' || report.summary.trackingtag == 'off'">
                <div class="flex-row">
                  設定を保存
                  <div class="loader--mini" v-show="setting_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <createList
      :create_list.sync="change_report"
      :type="'change_report'"
      :target_list_name="report.summary.report_name"
      :target_list_id="report.summary.report_id"
      @changeReportName="changeReportName"
    />

    <export-dialog :export_dialog.sync="export_dialog" :report_id="report_id" />

    <reportAddDrawer :add_csv_modal.sync="add_csv_modal" :report_id="report_id" @loadReport="loadReportDetail" @closeCreateReport="add_csv_modal = false" />
  </div>
</template>

<script>
import reportSummary from "./report_summary";
import mentiontagSuggest from "./mentiontag_suggest";
import influencerSuggest from "./influencer_suggest";
import createList from "../list/createList";
import reportPostList from "./report_post_list";
import reportInfluencer from "./report_influencer";
import exportDialog from "./report_export_dialog.vue";
import reportAddDrawer from "./report_add_drawer.vue";
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";
const root = process.env.VUE_APP_API;
const loadReportDetailAPI = root + "/api/report/load_reportdetail";
const addMediaAPI = root + "/api/report/add_media";
const addInfluencerAPI = root + "/api/report/add_influencer";
const refreshReportAPI = root + "/api/report/refresh";
const changeReportSettingAPI = root + "/api/report/change_report_setting";
const ImgUploadAPI = root + "/api/list/img_upload";

export default {
  name: "reportDetail",
  components: {
    UserTokenSiteInfo,
    reportSummary,
    mentiontagSuggest,
    influencerSuggest,
    createList,
    reportPostList,
    reportInfluencer,
    exportDialog,
    reportAddDrawer,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      activeName: "summary",
      report_id: "",
      report: {
        sns_type: "instagram",
        summary: [],
        post: [],
        influencer: [],
        influencer_list: [],
        report_switch: "left",
        checkList: [],
      },
      edit: {
        report_name: "",
        mentiontag: [],
        mentiontagValue: "",
        hashtag: [],
        hashtagValue: "",
        keyword: [],
        keywordValue: "",
      },
      done_data: true,
      trackingtag_on: false,
      change_flag: 0,
      loading: true,
      enter_on: false,
      mouseover: -1,
      img_change: false,
      file: "",
      fileList: [],
      account_name: "",
      checkList: [],
      checkListDetail: [],
      checkAll_val: false,
      checkedCount: 0,
      drawer: false,
      influencer_drawer: false,
      search_influencer: "",
      search_influencer_regexp: "",
      max_width: "100%",
      add_loading: false,
      setting_modal: false,
      setting_loading: false,
      graph_data: {},
      graphdetail_data: {},
      doughnut_data: [],
      reRender: 0,
      demo_notification: true,
      count: 0,
      result_count: 0,
      requestId: 0,
      change_report: false,
      add_influencer_modal: false,
      add_csv_modal: false,
      export_dialog: false,
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    export_report_enabled() {
      return this.$store.state.service_plan.export_report_enabled;
    },
    oneMonthLater() {
      var start = this.report.summary.start_at;
      if (start) {
        var startArray = start.split("-");
        var year = startArray[0];
        var month = Number(startArray[1]) + 1;
        var day = startArray[2];
        return year + "/" + month + "/" + day;
      } else {
        return "";
      }
    },
    end_at() {
      if (this.report.summary.end_at) {
        return this.report.summary.end_at;
      } else {
        return this.oneMonthLater;
      }
    },
  },
  created() {},
  mounted() {
    this.loadQuery();
    this.loadReportDetail();
  },
  methods: {
    loadReportDetail() {
      this.axios
        .get(loadReportDetailAPI, {
          params: {
            report_id: this.report_id == "demo" ? 1 : this.report_id,
            token: this.report_id == "demo" ? "demo" : this.token,
          },
        })
        .then((response) => {
          if (response.data.status == "OK") {
            this.report.sns_type = response.data.summary.sns_type;
            this.report.summary = response.data.summary;
            this.doughnut_data = response.data.doughnut_data;
            this.graph_data = response.data.graph_data;
            this.loading = false;
            if (this.report_id == "demo" || this.report.summary.influencer_num_done == 0) this.done_data = false;
          } else {
            this.$router.push("/404");
          }
        });
    },
    tabClick() {
      this.reRender += 1;
      this.count = 0;
      this.activeName == 'summary' ? this.loadReportDetail() : ''
    },
    addMedia() {
      this.$prompt("追加したい投稿のURLを入力してください", "投稿の追加", {
        showConfirmButton: this.report_id == "demo" ? "" : true,
        confirmButtonText: "追加",
        cancelButtonText: "キャンセル",
        inputPattern: /instagram\.com\/(p|reel)/,
        inputValue: name,
        inputErrorMessage: "正しいURLを入力してください",
      }).then(({ value }) => {
        this.$message({
          type: "info",
          offset: 7,
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: 'レポートに投稿を追加中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("media_url", value);
        params.append("sns_type", this.report.sns_type);
        params.append("report_id", this.report_id);
        params.append("token", this.token);
        this.axios
          .post(addMediaAPI, params)
          .then((response) => {
            this.$message.closeAll();
            if (response.data.status == "OK") {
              if (this.activeName == "media") this.$refs.reportPostList.reload();
              if (this.activeName == "influencer") this.$refs.reportInfluencer.reload();
              this.loadReportDetail();
              this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "投稿を追加しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
            } else if (response.data.message == "no-influencer") {
              this.$alert(`投稿データが${this.siteName} 上に存在しないため、レポートに追加できませんでした。`, "投稿データが取得できませんでした", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$alert("時間を空けて再度お試しください。", "投稿の追加に失敗しました", {
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "error",
            });
          });
      });
    },
    addInfluencer() {
      this.add_loading = true;
      var params = new URLSearchParams();
      params.append("report_id", this.report_id);
      params.append("sns_type", this.report.sns_type);
      params.append("influencer", JSON.stringify(this.report.influencer_list));
      params.append("token", this.token);
      this.axios
        .post(addInfluencerAPI, params)
        .then(() => {
          this.$router.push("/report");
          this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "インフルエンサーを追加しました", {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "success",
          });
        })
        .catch(() => {
          this.add_loading = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "インフルエンサーの追加に失敗しました",
          });
          this.$store.dispatch("loadSidemenuOption", this.token);
        });
    },
    refreshReport(show) {
      var params = new URLSearchParams();
      params.append("report_id", this.report_id);
      params.append("sns_type", this.report.sns_type);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      this.axios.post(refreshReportAPI, params).then(() => {
        this.loadReportDetail();
        if (show == true) {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "レポートを更新しました",
          });
        }
      });
    },
    addHashtag() {
      this.enter_on = true;
      if (this.edit.hashtag.length > 2 && this.edit.hashtagValue) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "ハッシュタグは最大3件までしか登録できません",
        });
      } else {
        let hashtagValue = this.edit.hashtagValue;
        if (hashtagValue) {
          this.edit.hashtag.push("#" + this.edit.hashtagValue);
        }
        this.edit.hashtagValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteHashtag(hashtag) {
      this.edit.hashtag.splice(this.edit.hashtag.indexOf(hashtag), 1);
    },
    addKeyword() {
      this.enter_on = true;
      if (this.edit.keyword.length > 2 && this.edit.keywordValue) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "キーワードは最大3件までしか登録できません",
        });
      } else {
        let keywordValue = this.edit.keywordValue;
        if (keywordValue) {
          this.edit.keyword.push(this.edit.keywordValue);
        }
        this.edit.keywordValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteKeyword(keyword) {
      this.edit.keyword.splice(this.edit.keyword.indexOf(keyword), 1);
    },
    settingOpen() {
      this.edit.report_name = this.report.summary.report_name.slice();
      this.edit.hashtag = this.report.summary.hashtag.slice();
      this.edit.keyword = this.report.summary.keyword.slice();
      this.setting_modal = true;
    },
    settingClose() {
      if (this.change_flag > 1) {
        this.$confirm("編集中の内容は保存されていません。", "設定画面を閉じてよろしいですか？", {
          confirmButtonText: "閉じる",
          cancelButtonText: "キャンセル",
          type: "warning",
        })
          .then(() => {
            this.setting_modal = false;
            this.change_flag = 0;
          })
          .catch(() => {});
      } else {
        this.setting_modal = false;
        this.change_flag = 0;
      }
    },
    openChangeReport() {
      this.change_report = true;
    },
    changeReportName(report_name) {
      this.report.summary.report_name = report_name;
    },
    changeReportSetting() {
      if (this.report_id == "demo") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "デモではご利用いただけません",
        });
      } else {
        this.setting_loading = true;
        var params = new URLSearchParams();
        params.append("report_id", this.report_id);
        params.append("hashtag", JSON.stringify(this.edit.hashtag));
        params.append("mentiontag", JSON.stringify(this.edit.mentiontag));
        params.append("keyword", JSON.stringify(this.edit.keyword));
        params.append("token", this.token);
        this.axios.post(changeReportSettingAPI, params).then(() => {
          this.$router.push("/report");
          this.$alert("レポートの更新に1~2分程度時間がかかる場合があります。", "レポートの設定を変更しました", {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "success",
          });
        });
      }
    },
    loadQuery() {
      this.loading = true;
      this.scrollTop();
      this.report_id = this.$route.params.report_id;
      this.noinfluencer = false;
      this.report.summary = [];
      this.report.post = [];
      this.report.influencer = [];
      this.checkList = [];
      this.count = 0;
    },
    imgAdd(file, fileList) {
      this.file = file;
      this.fileList = fileList;
    },
    imgUpload() {
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "report");
      formData.append("report_id", this.report_id);
      formData.append("token", this.token);
      this.axios.post(ImgUploadAPI, formData, config).then((response) => {
        this.report.summary.img_url = response.data[0].img_url;
        this.file = "";
        this.fileList = [];
        this.img_change = false;
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "レポートイメージ画像を変更しました",
        });
      });
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openInfluencer(value) {
      this.influencer_drawer = true;
      document.documentElement.style.overflow = "hidden";
      this.$router.push({
        name: "report_influencerDetailDrawer",
        params: {
          account_name: value,
          parent_component: "report",
          child: true,
        },
      });
    },
    closeInfluencer() {
      this.influencer_drawer = false;
      document.documentElement.style.overflow = "auto";
      this.$router.push({
        name: "reportDetail",
        params: {
          report_id: this.report_id,
        },
      });
    },
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    syncMentiontag(value) {
      this.edit.mentiontag = value;
    },
    inquiry() {
      this.$intercom.show();
    },
    imgError(index) {
      this.report.influencer[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    exportReportDetail() {
      if (this.$store.state.permission.export.access) {
        this.export_dialog = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  watch: {
    edit: {
      handler() {
        this.change_flag += 1;
      },
      deep: true,
    },
    $route(to) {
      if (to.name == "reportDetail" && !this.$route.params.backpage) {
        this.influencer_drawer = false;
      }
    },
    done_data() {
      this.count = 0;
      this.report.influencer = [];
    },
  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
    date(val) {
      const datetime_parse = val.replace(/-/g, "/");
      const date_after = datetime_parse.slice(0, -9);
      return date_after;
    },
    firstLetter(val) {
      return val.slice(0, 1);
    },
    lastUpadate(val) {
      const now = new Date();
      const lastUpdate = new Date(val);
      const diffSec = now.getTime() - lastUpdate.getTime();
      if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
  },
};
</script>

<style>
.btn-try-infinite {
  color: aqua !important;
}

.loading-spiral {
  border: 2px solid #0095f6 !important;
  border-right-color: transparent !important;
  -webkit-animation: loading-rotating-data-v-46b20d22 linear 0.85s infinite !important;
}

.el-checkbox__label {
  display: none;
}
</style>
